import React from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button
} from "reactstrap";

const DisputeStatusCheck = () => {
  const navigate= useNavigate()
  return (
    <div className="page-content bg-light ">
      <Container>
        <div className="d-flex justify-content-end mb-3">
          <Button className="btn btn-success" onClick={()=> navigate("/dispute-claim/form")}>
            Dispute claim
          </Button>
        </div>
        <Row className="justify-content-center">
          <Col md={6} lg={5}>
            <Card className="shadow-lg border-0 rounded-3">
              <CardBody className="p-4">
                <h4 className="text-center text-primary mb-4">
                  Check Dispute Claim Status
                </h4>

                <Form>
                  <FormGroup>
                    <Label for="claimId" className="fw-semibold">
                      Claim Reference ID
                    </Label>
                    <Input
                      id="claimId"
                      type="text"
                      placeholder="Enter your claim reference number"
                    />
                  </FormGroup>

                  <FormGroup>
                    <Label for="mobile" className="fw-semibold">
                      Registered Mobile Number
                    </Label>
                    <Input
                      id="mobile"
                      type="tel"
                      placeholder="e.g. 9800XXXXXX"
                    />
                  </FormGroup>

                  <FormGroup>
                    <Label for="date" className="fw-semibold">
                      Date of Transaction
                    </Label>
                    <Input id="date" type="date" />
                  </FormGroup>

                  <div className="d-grid mt-4">
                    <Link to="/disputeclaimdetail">
                    <Button color="primary" className="py-2 fw-semibold">
                      Check Status
                    </Button>
                    </Link>
                  </div>
                </Form>

                <p className="text-center text-muted mt-3 mb-0 small">
                  Need help? Contact our support at{" "}
                  <span className="text-primary fw-semibold">1234</span>.
                </p>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default DisputeStatusCheck;
